import { Button, Input } from '@attentive-platform/stem-ui';

const ApiKeySearchSection = ({ email, setEmail, onSearch, searchLoading }) => (
  <div className='flex flex-col gap-2 mb-2'>
    <label className='text-sm font-medium text-gray-700 block mb-1'>User email</label>
    <div className='flex flex-wrap gap-2'>
      <Input
        value={email}
        placeholder='User email'
        className='min-w-[240px] flex-1'
        onChange={e => setEmail(e.target.value)}
      />
      <Button color='primary' variant='outlined' onClick={onSearch} loading={searchLoading}>
        Search
      </Button>
    </div>
  </div>
);

export default ApiKeySearchSection;
